/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
// import { withStyles } from '@material-ui/core/styles';
// import useMediaQuery from '@material-ui/core/useMediaQuery';
import MetaTags from 'react-meta-tags';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';

import Box from "@material-ui/core/Box";
import GeneralStyles from '../../styles/GeneralStyles';
// import Chocco from '../../assets/images/careers/Chocco.jpg';
// // import Danny from '../../assets/images/careers/Danny.jpg';
// import Lidia from '../../assets/images/careers/Lidia.jpg';
// import Lucas from '../../assets/images/careers/Lucas.jpg';
// import Paul from '../../assets/images/careers/Paul.jpg';
// import Zarina from '../../assets/images/careers/Zarina.jpg';
// import Chris from '../../assets/images/careers/Chris.jpg';
import CircularProgress from '@material-ui/core/CircularProgress';


const useGeneralStyles = GeneralStyles;

function News(props) {
    const classesG = useGeneralStyles();
    const [loading, setLoading] = useState(false);
    const [careers, setCareers] = useState(null);
    const [employee, setEmployee] = React.useState([]);
    // const match = useMediaQuery('(min-width:600px)');

    useEffect(() => {
        setLoading(true);
        (async () => {
            const result = await axios.get(`${process.env.REACT_APP_GATEWAY_END_POINT}/careers`);
            setCareers(result.data);

            let arrayEmployees = [];
            const resultEmployee = await axios.get(`${process.env.REACT_APP_GATEWAY_END_POINT}/employees?_sort=Order:ASC`);
            resultEmployee.data.map((data, i) => (
                arrayEmployees.push({
                    id: data.id,
                    Name: data.Name,
                    Position: data.Position,
                    Country: data.Country,
                    Text: data.Text,
                    ImageName: data.Image.name,
                    ImageUrl: data.Image.url,
                    View: false
                })
            ));
            setEmployee(arrayEmployees);
            setLoading(false);
        })()
    }, []);

    // console.log('Employee: ' + JSON.stringify(employee));

    const [checked1, setChecked1] = React.useState(false);
    const [checked2, setChecked2] = React.useState(false);
    const [checked3, setChecked3] = React.useState(false);
    const [checked4, setChecked4] = React.useState(false);
    const [checked5, setChecked5] = React.useState(false);
    const [checked6, setChecked6] = React.useState(false);


    const handleClick = (param) => {
        if (employee.length > 0 && employee.length !== null) {
            var i = 0;
            var emp = employee;
            while (i < emp.length) {
                // console.log('ENTROOO4: ' + param + ' - ' + emp[i].id);
                if (param === emp[i].id) {
                    emp[i].View = emp[i].View === false ? true : false;
                } else {
                    emp[i].View = false;
                }
                i++;
            }
            setEmployee(emp);
        }
    }

    const handleCount = (param) => {
        var i = 0;
        var count = 0;
        var countCheck = 0;
        var result = {};
        while (i < employee.length) {
            if (employee.View === false) {
                count++;
            }
            if (param === employee.id && employee.View === true) {
                countCheck++;
            }
            i++;
        }
        result.count = count > 1 ? false : true;
        result.check = countCheck === 1 ? true : false;

        return result;
    }

    const handleClick1 = () => {
        setChecked1((prev) => !prev);
        setChecked2(false);
        setChecked3(false);
        setChecked4(false);
        setChecked5(false);
        setChecked6(false);
    };
    const handleClick2 = () => {
        setChecked2((prev) => !prev);
        setChecked1(false);
        setChecked3(false);
        setChecked4(false);
        setChecked5(false);
        setChecked6(false);

    };
    const handleClick3 = () => {
        setChecked3((prev) => !prev);
        setChecked1(false);
        setChecked2(false);
        setChecked4(false);
        setChecked5(false);
        setChecked6(false);
    };
    const handleClick4 = () => {
        setChecked4((prev) => !prev);
        setChecked1(false);
        setChecked2(false);
        setChecked3(false);
        setChecked5(false);
        setChecked6(false);
    };
    const handleClick5 = () => {
        setChecked5((prev) => !prev);
        setChecked1(false);
        setChecked2(false);
        setChecked3(false);
        setChecked4(false);
        setChecked6(false);
    };
    const handleClick6 = () => {
        setChecked6((prev) => !prev);
        setChecked1(false);
        setChecked2(false);
        setChecked3(false);
        setChecked4(false);
        setChecked5(false);
    };

    const multiple = (valor, multiple) => {
        var resto = valor % multiple;
        if (resto === 0)
            return true;
        else
            return false;
    }

    const replace = (param) => {
        var value = '';

        if (param !== '' && param !== null && param !== undefined) {
            value = param.replace(`${process.env.REACT_APP_GATEWAY_PATH_REPLACE}`, `${process.env.REACT_APP_GATEWAY_PATH_S3}`);
        }

        return value;
    }

    return (
        <React.Fragment>
            {loading && (
                <div className={classesG.divProgress}>
                    <CircularProgress size={68} className={classesG.progress} />
                </div>
            )}
            {!loading && (
                <React.Fragment>
                    {careers === null || careers === undefined ? '' : (
                        <React.Fragment>
                            <MetaTags>
                                <title>{careers.Page_title}</title>
                                <meta name="description" content={careers.Page_description} />
                            </MetaTags>

                            <div className={classesG.container}>

                                <section className={classesG.section}>
                                    <div className={classesG.careersSecondSectionContent}>
                                        <div className={classesG.sectionBox}>
                                            <div className={classesG.carrersfirstSectionText}>
                                                <h2>{careers.Title}</h2>
                                                <div dangerouslySetInnerHTML={{ __html: careers.Text }} />
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className={classesG.section}>
                                    <div className={classesG.careersSectionBackground}></div>
                                    <div className={classesG.careersSecondSectionContent}>
                                        <div className={classesG.careersSectionBox}>
                                            <div className={classesG.carrersSecondSectionText}>
                                                <h3>{careers.Positions_title}</h3>
                                                <ul>
                                                    {careers.positions.length === 0 || careers.positions.length === '' ? '' : careers.positions.map((items, i) => (
                                                        <li>
                                                            <a href={items.Url} target='_blank' rel="noreferrer">
                                                                <h4>{items.Position}</h4>
                                                                <span>{items.Country}</span>
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>

                                                <br />

                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className={classesG.section}>
                                    <div className={classesG.careersSecondSectionContent}>
                                        <div className={classesG.careersSectionBox}>
                                            <div className={classesG.carrersThirdSectionImagesV2}>
                                                <h3>{careers.Employees_title}</h3>
                                                {/* <ul>

                                                    {employee.length === 0 && employee.length === null ? '' :
                                                        employee.map((items, i) => (
                                                            <React.Fragment>
                                                                <li onClick={
                                                                    i == 0 ? handleClick1 :
                                                                        i == 1 ? handleClick2 :
                                                                            i == 2 ? handleClick3 :
                                                                                i == 3 ? handleClick4 :
                                                                                    i == 4 ? handleClick5 : handleClick6
                                                                }
                                                                    style={checked1 === false && checked2 === false && checked3 === false && checked4 === false && checked5 === false && checked6 === false ? { opacity: '1' } :
                                                                        i == 0 && checked1 === true ? { opacity: '1' } :
                                                                            i == 1 && checked2 === true ? { opacity: '1' } :
                                                                                i == 2 && checked3 === true ? { opacity: '1' } :
                                                                                    i == 3 && checked4 === true ? { opacity: '1' } :
                                                                                        i == 4 && checked5 === true ? { opacity: '1' } :
                                                                                            i == 5 && checked6 === true ? { opacity: '1' } : { opacity: '0.4' }}
                                                                >
                                                                    <img src={replace(items.ImageUrl)} alt={items.ImageName} />
                                                                    <h4 className={classesG.workH4_Black}>{items.Name}</h4>
                                                                    <p className={classesG.workP_Black}>{items.Position}</p>
                                                                    <p className={classesG.workP_Black}>{items.Country}</p>
                                                                </li>

                                                            </React.Fragment>

                                                        ))
                                                    }
                                                </ul>

                                                {employee.length === 0 && employee.length === null ? '' :
                                                    employee.map((items, i) => (
                                                        <div className={classesG.careersContainerCollapse}>

                                                            <Collapse in={
                                                                i == 0 ? checked1 :
                                                                    i == 1 ? checked2 :
                                                                        i == 2 ? checked3 :
                                                                            i == 3 ? checked4 :
                                                                                i == 4 ? checked5 : checked6
                                                            }
                                                                classes={{ container: classesG.careersCollapse }}
                                                            >
                                                                <div className={classesG.careersCollapseBackground} ></div>
                                                                <span className={
                                                                    i == 0 || i == 3 ? classesG.careersIndicator1 :
                                                                        i == 1 || i == 4 ? classesG.careersIndicator2 :
                                                                            classesG.careersIndicator3
                                                                }></span>
                                                                <br />
                                                                <br />
                                                                <div dangerouslySetInnerHTML={{ __html: items.Text }} />

                                                                <Button
                                                                    autoFocus
                                                                    color="primary"
                                                                    className={classesG.careersButtonClose}
                                                                    onClick={
                                                                        i == 0 ? handleClick1 :
                                                                            i == 1 ? handleClick2 :
                                                                                i == 2 ? handleClick3 :
                                                                                    i == 3 ? handleClick4 :
                                                                                        i == 4 ? handleClick5 : handleClick6
                                                                    }
                                                                >
                                                                    CLOSE
                                                                </Button>
                                                                <br />
                                                                <br />
                                                            </Collapse>
                                                        </div>
                                                    ))
                                                } */}

                                                {employee.length === 0 && employee.length === null ? '' :
                                                    <React.Fragment>
                                                        <ul>
                                                            <li onClick={handleClick1}
                                                                style={checked1 === false && checked2 === false && checked3 === false && checked4 === false && checked5 === false && checked6 === false ? { opacity: '1' } : checked1 === true ? { opacity: '1' } : { opacity: '0.4' }}
                                                            >
                                                                <img src={replace(employee[0].ImageUrl)} alt={employee[0].ImageName} />
                                                                <h4 className={classesG.workH4_Black}>{employee[0].Name}</h4>
                                                                <p className={classesG.workP_Black}>{employee[0].Position}</p>
                                                                <p className={classesG.workP_Black}>{employee[0].Country}</p>
                                                            </li>
                                                            <li onClick={handleClick2}
                                                                style={checked1 === false && checked2 === false && checked3 === false && checked4 === false && checked5 === false && checked6 === false ? { opacity: '1' } : checked2 === true ? { opacity: '1' } : { opacity: '0.4' }}
                                                            >
                                                                <img src={replace(employee[1].ImageUrl)} alt={employee[1].ImageName} />
                                                                <h4 className={classesG.workH4_Black}>{employee[1].Name}</h4>
                                                                <p className={classesG.workP_Black}>{employee[1].Position}</p>
                                                                <p className={classesG.workP_Black}>{employee[1].Country}</p>
                                                            </li>
                                                            <li onClick={handleClick3}
                                                                style={checked1 === false && checked2 === false && checked3 === false && checked4 === false && checked5 === false && checked6 === false ? { opacity: '1' } : checked3 === true ? { opacity: '1' } : { opacity: '0.4' }}
                                                            >
                                                                <img src={replace(employee[2].ImageUrl)} alt={employee[2].ImageName} />
                                                                <h4 className={classesG.workH4_Black}>{employee[2].Name}</h4>
                                                                <p className={classesG.workP_Black}>{employee[2].Position}</p>
                                                                <p className={classesG.workP_Black}>{employee[2].Country}</p>
                                                            </li>
                                                        </ul>

                                                        <div className={classesG.careersContainerCollapse}>

                                                            <Collapse in={checked1} classes={{ container: classesG.careersCollapse }} >
                                                                <div className={classesG.careersCollapseBackground} ></div>
                                                                <span className={classesG.careersIndicator1}></span>
                                                                <br />
                                                                <br />
                                                                <div dangerouslySetInnerHTML={{ __html: employee[0].Text }} />

                                                                <Button
                                                                    autoFocus
                                                                    color="primary"
                                                                    className={classesG.careersButtonClose}
                                                                    onClick={handleClick1}
                                                                >
                                                                    CLOSE
                                                                </Button>
                                                                <br />
                                                                <br />
                                                            </Collapse>

                                                            <Collapse in={checked2} classes={{ container: classesG.careersCollapse }}>
                                                                <div className={classesG.careersCollapseBackground} ></div>
                                                                <span className={classesG.careersIndicator2}></span>
                                                                <br />
                                                                <br />
                                                                <div dangerouslySetInnerHTML={{ __html: employee[1].Text }} />
                                                                <Button
                                                                    autoFocus
                                                                    color="primary"
                                                                    className={classesG.careersButtonClose}
                                                                    onClick={handleClick2}
                                                                >
                                                                    CLOSE
                                                                </Button>
                                                                <br />
                                                                <br />
                                                            </Collapse>

                                                            <Collapse in={checked3} classes={{ container: classesG.careersCollapse }}>
                                                                <div className={classesG.careersCollapseBackground} ></div>
                                                                <span className={classesG.careersIndicator3}></span>
                                                                <br />
                                                                <br />
                                                                <div dangerouslySetInnerHTML={{ __html: employee[2].Text }} />
                                                                <Button
                                                                    autoFocus
                                                                    color="primary"
                                                                    className={classesG.careersButtonClose}
                                                                    onClick={handleClick3}
                                                                >
                                                                    CLOSE
                                                                </Button>
                                                                <br />
                                                                <br />
                                                            </Collapse>
                                                        </div>
                                                        <ul>
                                                            <li onClick={handleClick4}
                                                                style={checked1 === false && checked2 === false && checked3 === false && checked4 === false && checked5 === false && checked6 === false ? { opacity: '1' } : checked4 === true ? { opacity: '1' } : { opacity: '0.4' }}
                                                            >
                                                                <img src={replace(employee[3].ImageUrl)} alt={employee[3].ImageName} />
                                                                <h4 className={classesG.workH4_Black}>{employee[3].Name}</h4>
                                                                <p className={classesG.workP_Black}>{employee[3].Position}</p>
                                                                <p className={classesG.workP_Black}>{employee[3].Country}</p>
                                                            </li>

                                                            <li onClick={handleClick5}
                                                                style={checked1 === false && checked2 === false && checked3 === false && checked4 === false && checked5 === false && checked6 === false ? { opacity: '1' } : checked5 === true ? { opacity: '1' } : { opacity: '0.4' }}
                                                            >
                                                                <img src={replace(employee[4].ImageUrl)} alt={employee[4].ImageName} />
                                                                <h4 className={classesG.workH4_Black}>{employee[4].Name}</h4>
                                                                <p className={classesG.workP_Black}>{employee[4].Position} </p>
                                                                <p className={classesG.workP_Black}>{employee[4].Country}</p>
                                                            </li>

                                                            <li onClick={handleClick6}
                                                                style={checked1 === false && checked2 === false && checked3 === false && checked4 === false && checked5 === false && checked6 === false ? { opacity: '1' } : checked6 === true ? { opacity: '1' } : { opacity: '0.4' }}
                                                            >
                                                                <img src={replace(employee[5].ImageUrl)} alt={employee[5].ImageName} />
                                                                <h4 className={classesG.workH4_Black}>{employee[5].Name}</h4>
                                                                <p className={classesG.workP_Black}>{employee[5].Position}</p>
                                                                <p className={classesG.workP_Black}>{employee[5].Country}</p>
                                                            </li>
                                                        </ul>

                                                        <div className={classesG.careersContainerCollapse}>
                                                            <Collapse in={checked4} classes={{ container: classesG.careersCollapse }}>
                                                                <div className={classesG.careersCollapseBackground} ></div>
                                                                <span className={classesG.careersIndicator1}></span>
                                                                <br />
                                                                <br />
                                                                <div dangerouslySetInnerHTML={{ __html: employee[3].Text }} />
                                                                <Button
                                                                    autoFocus
                                                                    color="primary"
                                                                    className={classesG.careersButtonClose}
                                                                    onClick={handleClick4}
                                                                >
                                                                    CLOSE
                                                                </Button>
                                                                <br />
                                                                <br />
                                                            </Collapse>

                                                            <Collapse in={checked5} classes={{ container: classesG.careersCollapse }}>
                                                                <div className={classesG.careersCollapseBackground} ></div>
                                                                <span className={classesG.careersIndicator2}></span>
                                                                <br />
                                                                <br />
                                                                <div dangerouslySetInnerHTML={{ __html: employee[4].Text }} />
                                                                <Button
                                                                    autoFocus
                                                                    color="primary"
                                                                    className={classesG.careersButtonClose}
                                                                    onClick={handleClick5}
                                                                >
                                                                    CLOSE
                                                                </Button>
                                                                <br />
                                                                <br />
                                                            </Collapse>

                                                            <Collapse in={checked6} classes={{ container: classesG.careersCollapse }}>
                                                                <div className={classesG.careersCollapseBackground} ></div>
                                                                <span className={classesG.careersIndicator3}></span>
                                                                <br />
                                                                <br />
                                                                <div dangerouslySetInnerHTML={{ __html: employee[5].Text }} />
                                                                <Button
                                                                    autoFocus
                                                                    color="primary"
                                                                    className={classesG.careersButtonClose}
                                                                    onClick={handleClick6}
                                                                >
                                                                    CLOSE
                                                                </Button>
                                                                <br />
                                                                <br />
                                                            </Collapse>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </div>

                                        </div>
                                    </div>
                                </section>

                                <Box mt={7}></Box>
                            </div>
                        </React.Fragment>
                    )}
                </React.Fragment>
            )
            }
        </React.Fragment >
    );
}

export default (News);